import { compensationActionTypes } from "../ActionTypes/compensationActionTypes";
import forms from "../Constants/forms";
import * as formValidationRules from "../Constants/formValidationRules";
import formActions from "./formActions";
import commonActions from "./commonActions";
import { httpFetch, httpFetchNoEncode } from "../Utils/httpUtils";
import { commonActionTypes } from "../ActionTypes/commonActionTypes";
import { CompensationStatus } from "../Constants/Compensations/compensationStatus";
import { settingsActionTypes } from "../ActionTypes/settingsActionTypes";

const compensationActions = {

    getCompensationTickets({ searchPhrase, customerNumber, status, responsibleManager } = {}, actionType = compensationActionTypes.STORE_COMPENSATION_TICKETS) {

        const params = new URLSearchParams();
        if (searchPhrase) params.append('searchPhrase', searchPhrase);
        if (customerNumber) params.append('customerNumber', customerNumber);
        if (status) params.append('status', status);
        if (responsibleManager) params.append('responsibleManager', responsibleManager);

        return (dispatch) => {
            dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "compensations", value: true });
            return httpFetchNoEncode(`/api/compensations/?${params.toString()}`, dispatch).then(json => {
                dispatch({ type: actionType, data: json });
            }).finally(() => {
                dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "compensations", value: false });
            });
        };
    },

    getSelectedTicketForEdit(id) {
        return (dispatch) => {
            dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "compensationTicketForm", value: true });
            return httpFetch(`/api/compensations/${id}/edit`, dispatch).then(json => {

                const formData = {
                    resultId: json.resultId,
                    subResultId: json.subResultId,
                    sum: json.sum,
                    comment: json.comment
                };

                dispatch({ type: settingsActionTypes.STORE_COMPENSATION_TICKET, data: json });
                dispatch(formActions.startFormEditing(forms.compensationTicketFormData, formData, json.status === CompensationStatus.Open ? formValidationRules.settingsCompensationTicket : null))
            }).finally(() => {
                dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "compensationTicketForm", value: false });
            });
        }
    },

    beginCompensationSendForm(customer, product) {
        return (dispatch) => {
            
            const requestBody = {
                customerNumber: customer.vbCustomer.customerNumber,
                productId: product.id,
                subscriptionId: product.subscriptionId,
                sourceSystem: product.sourceSystem
            };

            const httpRequest = {
                method: 'POST',
                body: JSON.stringify(requestBody),
            };

            const contactPerson = customer.vossCustomer?.contactPerson ?? customer.vbCustomer.contactPerson; 

            dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "compensationForm", value: true });
            return httpFetch(`/api/compensations/initialize/`, dispatch, httpRequest)
                .then(response => {
                    const { initialData, restrictions } = response;

                    const formData = {
                        ...initialData,
                        reasonId: null,
                        product: product.product ?? "",
                        subscriptionId: product.subscriptionId,
                        productName: product.name,
                        sourceSystem: product.sourceSystem,
                        customerId: customer.vossCustomer?.id,
                        customerNumber: customer.vbCustomer.customerNumber,
                        customerName: customer.name,
                        customerPhone: contactPerson?.phoneNumber ?? "",
                        customerEmail: contactPerson?.email ?? "",
                        contactPerson: [
                            contactPerson?.firstName,
                            contactPerson?.lastName
                        ].filter(Boolean).join(" "),
                        restrictions: restrictions
                    };

                    dispatch(formActions.startFormEditing(forms.compensationFormData, formData, formValidationRules.CompensationContactCustomer));
                }).finally(() => {
                    dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "compensationForm", value: false });
                });
        };
    },

    getCompensationSum(product, customerNumber, months, callback) {
        return (dispatch) => {

            const requestBody = {
                product: product.product,
                sourceSystem: product.sourceSystem,
                period: product.period,
                users: product.users,
                api: product.api,
                subscriptionId: product.subscriptionId,
                customerNumber,
                months
            };

            const httpRequest = {
                method: 'POST',
                body: JSON.stringify(requestBody),
            };

            dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "compensationSum", value: true });
            return httpFetch(`/api/compensations/compensationsum/`, dispatch, httpRequest).then(json => {
                callback(json);
            }).finally(() => {
                dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "compensationSum", value: false });
            });
        };
    },

    sendCompensation(compensationForm, callback) {
        return (dispatch) => {

            const httpRequest = {
                method: 'POST',
                body: JSON.stringify(compensationForm.data)
            };

            dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "compensationForm", value: true });
            return httpFetch('/api/compensations/send', dispatch, httpRequest).then(json => {
                if (callback)
                    callback();
                dispatch(commonActions.showSuccess('Request has been sent'));
            }).finally(() => {
                dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "compensationForm", value: false });
            });
        };
    },

    saveTicket(id, form, callback) {
        return (dispatch) => {

            const httpRequest = {
                method: 'PUT',
                body: JSON.stringify(form.data)
            }

            dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "compensationTicketForm", value: true });
            return httpFetch(`/api/compensations/${id}/edit/`, dispatch, httpRequest)
                .then(json => {
                    dispatch(commonActions.showSuccess('Ticket has been successfully saved!'));
                    if (callback)
                        callback();
                }).finally(() => {
                    dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "compensationTicketForm", value: false });
                });
        };
    },

    deleteTicket(id, callback) {
        return (dispatch) => {

            const httpRequest = {
                method: 'DELETE',
            };

            dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "compensationDeletion", value: true });
            return httpFetch(`/api/compensations/${id}`, dispatch, httpRequest)
                .then(json => {
                    callback();
                    dispatch(commonActions.showSuccess('Ticket has been successfully deleted!'));
                }).finally(() => {
                    dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "compensationDeletion", value: false });
                });
        }
    }
};

export default compensationActions;